<div class="c-randomprizeStart">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-randomprizeStart__container">
    <div
      class="c-randomprizeStart__background"
      theming
      themingGroup="randomprize"
      themingAsset="start-background"
      [themingOverride]="event()?.assets">
      <div
        class="c-randomprizeStart__info"
        [ngClass]="hasMinPurchase() ? 'less-margin' : ''">
        <div
          class="c-randomprizeStart__icon"
          theming
          themingGroup="randomprize"
          themingAsset="logo"
          [themingOverride]="event()?.assets"></div>

        <div class="c-randomprizeStart__text">
          <span class="text title">
            {{ 'home.live-ops.randomprize.modal-start.title' | translate }}
            <br /><span class="text maxPrize">{{ randomprizeStartModalData.properties.maxMultiplier }}&#37;</span><br />
          </span>
          <span
            class="text title"
            [ngClass]="lang() === 'fr' ? 'title-fr' : ''"
            >{{ 'home.live-ops.randomprize.modal-start.title-2' | translate }}</span
          >
        </div>

        @if (hasMinPurchase()) {
          <slotcom-box [classes]="['minPurchase', 'minPurchase--randomprize']">
            <span class="text"
              >{{ 'home.live-ops.global.min-purchase' | translate }} {{ randomprizeMinPurchase() | number }}
              {{ randomprizeCurrencySymbol() }}</span
            >
          </slotcom-box>
        }

        @if (event() && event().infiniteTimes) {
          <slotcom-box
            class="maxCompletionTimes"
            [classes]="['maxCompletionTimes']">
            @if (!event().infiniteTimes && event().maxCompletionTimes === 1) {
              <span class="text times">{{ 'home.live-ops.global.times-valid-coins' | translate }}</span>
            }
            @if (!event().infiniteTimes && event().maxCompletionTimes > 1) {
              <span class="text times">{{
                'home.live-ops.global.times-valid-coins-2' | translate: { times: event().maxCompletionTimes }
              }}</span>
            }
            @if (event().infiniteTimes) {
              <span class="text times">{{ 'home.live-ops.global.times-valid-coins-3' | translate }}</span>
            }
          </slotcom-box>
        }

        <div class="c-randomprizeStart__timer">
          <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
          <slotcom-animated-timer
            [showInDays]="true"
            [endDate]="randomprizeStartModalData.expirationDate"
            (expired)="closeModal()"></slotcom-animated-timer>
        </div>
      </div>

      <slotcom-button
        class="c-button--pink"
        (safeClick)="openRandomPrize()"
        audioType="functionality">
        {{
          randomprizeStartModalData.properties.buttonText[lang()]
            ? randomprizeStartModalData.properties.buttonText[lang()]
            : ('home.buttons.going-to-get-lucky' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </div>
</div>
